import { Component, DoCheck, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-demo-loader',
  templateUrl: './demo-loader.component.html',
  styleUrls: ['./demo-loader.component.css']
})
export class DemoLoaderComponent implements OnInit, DoCheck {

  origin = window.location.origin;
  pathname = window.location.pathname;

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
  }

  ngDoCheck() {
    // Reset Demo Account Local Storage
    if ((this.origin === 'https://demo.notchcx.io' || this.origin === 'http://localhost:1100') && this.pathname === '/demoloader') {
      const currentUser = localStorage.getItem('currentUser');
      this.route.queryParams.subscribe(query => {
        let stringQuery = Object.keys(query)[0];

        if (stringQuery) {
          (currentUser && stringQuery) ? localStorage.removeItem('currentUser') : null;
          if (!currentUser) {
            localStorage.setItem("currentUser", stringQuery);
            // reload after setting localstorage
            this.router.navigate(['/dashboard'])
            setTimeout(() => {
              window.location.reload()
            }, 1500);
          }
        }
      })
    }
    // Reset Demo Ends
  }


}
